declare const __APP_VERSION__: string;
declare const __PLATFORM__: "web" | "desktop" | "android";

function required(name: string): string {
  const v = import.meta.env[name] as string | undefined;
  if (!v) console.warn(`Falta la variable ${name} (ver .env.example)`);
  return v ?? "";
}

/** Deja solo https://xxxx.supabase.co aunque se pegue con "/", "/rest/v1/", comillas o espacios. */
export function baseUrl(raw: string): string {
  const v = raw.trim().replace(/^["']|["']$/g, "");
  // Si se pegó la dirección del panel (supabase.com/dashboard/project/REF), se arma la del proyecto.
  const dash = v.match(/supabase\.com\/dashboard\/project\/([a-z0-9]+)/i);
  if (dash) return `https://${dash[1]}.supabase.co`;
  try { return new URL(v).origin; } catch { return v.replace(/\/+$/, ""); }
}

export const env = {
  supabaseUrl: baseUrl(required("VITE_SUPABASE_URL")),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY").trim().replace(/^["']|["']$/g, ""),
  powersyncUrl: baseUrl(required("VITE_POWERSYNC_URL")),
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "",
  appUrl: (import.meta.env.VITE_APP_URL as string | undefined) ?? window.location.origin,
  /** "pruebas" en el entorno de pruebas (se muestra una franja para no confundirlo con el real). */
  entorno: ((import.meta.env.VITE_ENTORNO as string | undefined) ?? "").trim(),
  /** "driver" en la app Sofía Reparto (solo el reparto); "pos" en la del negocio. */
  flavor: ((import.meta.env.VITE_APP_FLAVOR as string | undefined) ?? "").trim() === "driver" ? "driver" as const : "pos" as const,
  version: __APP_VERSION__,
  platform: __PLATFORM__,
};

/** "Versión 1.46.0 · Windows": lo que tiene instalado este equipo (se ve en el menú y al ingresar). */
export function versionLabel(e: { version: string; platform: string; flavor: string } = env): string {
  const where = e.flavor === "driver" ? "Sofía Reparto" : e.platform === "desktop" ? "Windows" : e.platform === "android" ? "Android" : "Web";
  return `Versión ${e.version} · ${where}`;
}
